import React from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { localized } from 'decorators'
import { DashboardItem, COLORS, formatters } from 'components/dashboard'
import { api } from 'store/modules/dashboard'

import { useStyles } from './index.css'

const createPie = ({ data, cx, cellKey, type }) => {
  return (
    <Pie data={data} cx={cx} cy={80} outerRadius={80} labelLine={false} dataKey='value'>
      {data.map((entry, index) => <Cell key={`${cellKey}-${index}`} type={type} fill={COLORS[index % COLORS.length]} />)}
    </Pie>
  )
}

export const TopSuppliers = localized(({ localize }) => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  const handleData = React.useCallback(x => setData(x), [])

  return (
    <DashboardItem
      title={localize('dashboard.topSuppliers_title')}
      dataSource={api.getTopSuppliers}
      bodyClassName={classes.root}
      onDataReceived={handleData}>
      {data && 
      <PieChart width={400} height={170}>
        {createPie({ data: data.bottles, cx: 95, cellKey: 'cell-bottles', type: 'bottles' })}
        {createPie({ data: data.prices, cx: 295, cellKey: 'cell-prices', type: 'prices' })}
        <Tooltip formatter={(value, name, props) => formatters(localize)[props.payload.type](value)} />
      </PieChart>}
      {data && <React.Fragment>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                <TableCell colSpan={2} align='center'>{localize('dashboard.topSuppliers_byBottles')}</TableCell>
                <TableCell colSpan={2} align='center'>{localize('dashboard.topSuppliers_byPrices')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>
              {data.bottles.map((_, idx) => <TableRow key={idx} className={classes.tableRow}>
                  <TableCell>{data.bottles[idx].name}</TableCell>
                  <TableCell align='right'>{formatters(localize).bottles(data.bottles[idx].value)}</TableCell>
                  <TableCell>{data.prices[idx].name}</TableCell>
                  <TableCell align='right'>{formatters(localize).prices(data.prices[idx].value)}</TableCell>
                </TableRow>)
              }
            </TableBody>
          </Table>
        </React.Fragment>}
    </DashboardItem>
  )
})
